import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { SuggestionChip } from '../../../../../../core/src';

@Component({
  selector: 'inbox-chat-empty-state',
  imports: [MatIconModule, GalaxyBadgeModule, GalaxyEmptyStateModule],
  templateUrl: './inbox-chat-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './inbox-chat-empty-state.component.scss',
})
export class InboxChatEmptyStateComponent {
  @Input() title!: string;
  @Input() description!: string;
  @Input() avatarUrl?: string;
  @Input() iconName?: string;
  @Input() suggestionChips: SuggestionChip[] = [];

  @Output() suggestionClicked = new EventEmitter<SuggestionChip>();

  onSuggestionClick(chip: SuggestionChip): void {
    this.suggestionClicked.emit(chip);
  }
}
